module.exports = __webpack_public_path__ + "static/media/65.e204d022.jpg";